import CommonNotificationSettingChange from '../../../common/pages/secure/NotificationSettingChange'

class NotificationSettingChange extends CommonNotificationSettingChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
  }
}

export default NotificationSettingChange



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/NotificationSettingChange.js